import { Injectable, inject } from '@angular/core';
import { LendersGroupViewModel } from '@shared/models/lender-group';
import { ClubHubDataService } from '@shared/services/clubhub-data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LendersGroupsService {
  private readonly clubHubDataService = inject(ClubHubDataService);

  private readonly endpointName = 'LendersGroup';

  public getLenderGroups(): Observable<LendersGroupViewModel[]> {
    return this.clubHubDataService.get<LendersGroupViewModel[]>(this.endpointName);
  }

  public updateLenderGroup(group: LendersGroupViewModel): Observable<void> {
    return this.clubHubDataService.post(this.endpointName, group);
  }
}
